import * as React from "react";
import { useState } from "react";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Avatar from "@mui/material/Avatar";
import { styled, useTheme } from "@mui/material/styles";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";

import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import CardHeader from "@mui/material/CardHeader";
import useMediaQuery from "@mui/material/useMediaQuery";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";

import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";

import IconButton from "@mui/material/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SettingsIcon from "@mui/icons-material/Settings";
import GroupIcon from "@mui/icons-material/Group";
import PaidIcon from "@mui/icons-material/Paid";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { useAuth } from "../../Shared/Providers/Auth.provider";
import { Link } from "react-router-dom";

const drawerWidth = "15vw";

const openedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
});

const AppDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function Nav(props) {
  const { logout } = useAuth();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(true);
  const [openUser, setOpenUser] = React.useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(!open);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenUser(false);
  };

  const handleOpenUser = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenUser(true);
  };

  const toggleDrawer = () => {
    setOpen(!open);
    props.onChange(open);
  };

  return (
    <React.Fragment>
      {!isMobile ? (
        <>
          <AppBar
            position="static"
            sx={{
              width: `calc(100% - ${drawerWidth}px)`,
              ml: `${drawerWidth}px`,
            }}
            style={{
              background: "transparent",
              boxShadow: "none",
              backgroundImage: "none",
            }}
          >
            <Toolbar>
              <Box sx={{ flexGrow: 1 }} />
              <Box sx={{ display: "inline-flex" }}>
                <Stack direction="row" spacing={2}>
                  <IconButton
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    variant="outlined"
                    component={Link}
                    to="/settings"
                    sx={{
                      background:
                        "linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))",
                      borderRadius: "6px",
                      height: 40,
                      width: 40,
                      marginTop: "auto !important",
                      marginBottom: "auto !important",
                    }}
                  >
                    <SettingsIcon />
                  </IconButton>
                  <IconButton
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    variant="outlined"
                    onClick={logout}
                    sx={{
                      background:
                        "linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))",
                      borderRadius: "6px",
                      height: 40,
                      width: 40,
                      marginTop: "auto !important",
                      marginBottom: "auto !important",
                    }}
                  >
                    <LogoutIcon />
                  </IconButton>
                  <CardHeader
                    avatar={
                      <Avatar
                        alt={props.name}
                        src={props.image}
                        sx={{ bgcolor: "white" }}
                      />
                    }
                    title={props.name}
                  />
                </Stack>
              </Box>
            </Toolbar>
          </AppBar>

          <AppDrawer
            sx={{
              flexShrink: 0,
              "& .MuiDrawer-paper": {
                width: open ? "15vw !important" : "4vw !important",
                boxSizing: "border-box",
              },
            }}
            PaperProps={{
              sx: {
                backgroundColor: "#25164f",
                zIndex: "999 !important",
              },
            }}
            variant="permanent"
            anchor="left"
          >
            <Box
              sx={{ width: "100%", textAlign: "center" }}
              role="presentation"
            >
              <IconButton
                onClick={toggleDrawer}
                sx={{ display: "block", position: "absolute", right: "2%" }}
              >
                {open ? <ChevronRightIcon /> : <ChevronLeftIcon />}
              </IconButton>
              <Link to="/">
                <Box
                  component="img"
                  src={open ? "/assets/logo.png" : "/assets/logo-icon.png"}
                  style={{
                    marginTop: "40px",
                    marginBottom: "20px",
                    width: "80%",
                  }}
                />
              </Link>
              <Divider
                sx={{
                  marginLeft: "40px",
                  marginRight: "40px",
                  marginBottom: "20px",
                }}
              />
              <List>
                <ListItem
                  key={"Dashboard"}
                  component={Link}
                  to="/"
                  sx={{
                    paddingLeft: "44px",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                  }}
                >
                  <ListItemIcon>
                    <DashboardIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Inicio"} />
                </ListItem>
                <ListItem
                  key={"Add Funds"}
                  component={Link}
                  to="accounts"
                  style={{
                    paddingLeft: "44px",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                  }}
                >
                  <ListItemIcon>
                    <GroupIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Cuentas"} />
                </ListItem>
                <ListItem
                  key={"Funds"}
                  component={Link}
                  to="funds"
                  style={{
                    paddingLeft: "44px",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                  }}
                >
                  <ListItemIcon>
                    <PaidIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Fondeos"} />
                </ListItem>
                <ListItem
                  key={"card-funds"}
                  component={Link}
                  to="card-funds"
                  style={{
                    paddingLeft: "44px",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                  }}
                >
                  <ListItemIcon>
                    <CreditCardIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Fondeos de Tarjetas"} />
                </ListItem>
                <ListItem
                  key={"Transfers"}
                  component={Link}
                  to="transfers"
                  style={{
                    paddingLeft: "44px",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                  }}
                >
                  <ListItemIcon>
                    <AccountBalanceIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Transferencias"} />
                </ListItem>
              </List>
            </Box>
          </AppDrawer>
        </>
      ) : (
        <AppBar
          position="relative"
          sx={{ zIndex: 1, backgroundImage: "none !important" }}
        >
          <Toolbar>
            <>
              <IconButton onClick={() => setOpenDrawer(!openDrawer)}>
                <MenuIcon />
              </IconButton>
              <Box sx={{ flexGrow: 1 }} />
              <Avatar
                onClick={handleOpenUser}
                alt={props.name}
                src={props.image}
                sx={{ bgcolor: "white", marginLeft: 5 }}
              />
            </>
          </Toolbar>
          <Drawer
            open={openDrawer}
            onClose={() => setOpenDrawer(false)}
            onClick={() => setOpenDrawer(false)}
            PaperProps={{
              sx: {
                backgroundImage: "none !important",
              },
            }}
          >
            <Box
              sx={{
                width: { xs: "80vw" },
                maxWidth: "350px",
                textAlign: "center",
              }}
              role="presentation"
            >
              <Link to="/">
                <Box
                  component="img"
                  src="/assets/logo.png"
                  style={{
                    marginTop: "30px",
                    marginBottom: "20px",
                    width: "80%",
                  }}
                />
              </Link>
              <List>
                <ListItem
                  key={"Dashboard"}
                  component={Link}
                  to="/"
                  sx={{
                    paddingLeft: "44px",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                  }}
                >
                  <ListItemIcon>
                    <DashboardIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Inicio"} />
                </ListItem>
                <ListItem
                  key={"Add Funds"}
                  component={Link}
                  to="accounts"
                  style={{
                    paddingLeft: "44px",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                  }}
                >
                  <ListItemIcon>
                    <GroupIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Cuentas"} />
                </ListItem>
                <ListItem
                  key={"Funds"}
                  component={Link}
                  to="funds"
                  style={{
                    paddingLeft: "44px",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                  }}
                >
                  <ListItemIcon>
                    <PaidIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Fondeos"} />
                </ListItem>
                <ListItem
                  button
                  key={"card-funds"}
                  button
                  component={Link}
                  to="card-funds"
                  style={{
                    paddingLeft: "44px",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                  }}
                >
                  <ListItemIcon>
                    <CreditCardIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Fondeos de Tarjetas"} />
                </ListItem>
                <ListItem
                  key={"Transfers"}
                  component={Link}
                  to="transfers"
                  style={{
                    paddingLeft: "44px",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                  }}
                >
                  <ListItemIcon>
                    <AccountBalanceIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Transferencias"} />
                </ListItem>
              </List>
            </Box>
          </Drawer>
        </AppBar>
      )}
      <Menu
        anchorEl={anchorEl}
        open={openUser}
        onClose={handleClose}
        onClick={handleClose}
      >
        <MenuList>
          <MenuItem onClick={logout} button>
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Logout</ListItemText>
          </MenuItem>
        </MenuList>
      </Menu>
    </React.Fragment>
  );
}
